<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive">
        <!-- 这里是会被缓存的视图组件 -->
      </router-view>
    </keep-alive>

    <router-view v-if="!$route.meta.keepAlive">
      <!-- 这里是不会被缓存的视图组件 -->
    </router-view>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import tools from '@/utils/tools.js'
export default {
  name: 'App',
  data() {
    return {
      logo: require('@/assets/logo.png'), //icon路径
      // 这里可以放置一些全局变量
      scale: null,
      scaleCopy: null,
    }
  },
  watch: {
    // 这里可以监听一些全局变量的变化
    $route: {
      handler(n, o) {
        if (n.path == '/' || n.path == '/Login' || n.path == '/UserSign') {
          return
        }
        if (this.userInfo.ProjectStatus == 2) {
          if (n.path == '/UserInfo') {
            return
          }
          if (n.path == '/HomeInfo') {
            return
          }
          let MenuArr = tools.getAllChildren(this.Menu)
          let index = MenuArr.findIndex((item) => {
            return item.path == n.path
          })
          if (index > -1) {
            console.log('有效')
            return
          } else {
            this.$notify.warning('该页面无法访问，已跳转到首页')
            console.log(MenuArr)
            this.$router.replace('/HomeInfo')
          }
          //项目关闭后 Before 都无法访问 Before 路由都为ProjectInfo 开头
          if (n.path.indexOf('ProjectInfo') > -1) {
            this.$notify.warning('该页面无法访问，已跳转到登录首页')
            this.$router.replace('/Login')
          }
        } else {
          if (n.path == '/User') {
            return
          }
          //项目未关闭，必须都是访问 ProjectInfo 开头的路由 其他无法访问 Before 路由都为ProjectInfo 开头 用户信息除外
          if (n.path.indexOf('ProjectInfo') == -1) {
            this.$notify.warning('该页面无法访问，已跳转到登录首页')
            this.$router.replace('/Login')
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    // 这里可以定义一些计算属性
    ...mapState(['userInfo', 'Menu']),
  },
  created() {
    // 这里可以执行一些初始化操作
    var link =
      document.querySelector("link[rel*='icon']") ||
      document.createElement('link')
    link.type = 'image/x-icon'
    link.rel = 'shortcut icon'
    link.href = this.logo // icon地址
    document.getElementsByTagName('head')[0].appendChild(link)
  },
  mounted() {
    this.setScale() // 初始时立即执行一次，
    // 监听页面缩放变化
    window.addEventListener('resize', this.setScale)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setScale)
  },
  methods: {
    checkIsMobile() {
      const ua = navigator.userAgent.toLowerCase()
      const isMobile =
        /phone|pad|pod|iphone|ipod|ios|ipad|android|mobile|blackberry|iemobile|mqqbrowser|juc|fennec|wosbrowser|browserng|webos|symbian/i.test(
          ua
        )
      this.isMobile = isMobile
      return isMobile
    },
    setScale() {
      // 获取当前缩放比例
      console.log(window.devicePixelRatio, 'window.devicePixelRatio')
      this.scaleCopy = this.scale
      if (window.devicePixelRatio) {
        this.scale = Number((window.devicePixelRatio * 100).toFixed(2))
      }
      if (this.scale !== 100) {
        if (this.checkIsMobile()) {
          return
        }
        if (this.scaleCopy === this.scale) {
          return
        }

        let str = `<span style="color:red;font-size:20px"> 当前页面缩放比例为${this.scale}%,页面布局可能会错位，请尽量保持100%缩放。</span><br/><span style="color:#000;font-size:16px">可以Ctrl键+鼠标滚轮或Ctrl键+加号或减号来缩放页面，或者电脑显示设置缩放。</span>`
        this.$notify({
          title: '注意',
          dangerouslyUseHTMLString: true,
          message: str,
          duration: 2000,
        })
        // this.$alert(str, '注意!', {
        //   confirmButtonText: '确定',
        //   dangerouslyUseHTMLString: true,

        //   callback: () => {},
        // })
      }
    },
  },
}
</script>
<style lang="scss">
* {
  box-sizing: border-box;
  font-family: Arial, sans-serif;
}
html,
body {
  overflow: hidden;
}
.icon,
.iconfont {
  font-family: 'iconfont' !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
i {
  font-style: normal;
}
::v-deep.el-button {
  outline: none;
  border: none;
}

#app {
  height: 100vh;
  width: 100vw;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.el-select {
  width: 100%;
}

button:focus {
  outline: none;
}

.el-button:focus {
  outline: none;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type='number'] {
  -moz-appearance: textfield;
}

.h5-confirm-class {
  width: 70vw !important;
}

.dateime {
  .el-picker-panel__footer {
    .el-button--text {
      display: none;
    }
  }
}

.cascader-popper {
  z-index: 9000 !important;
}
.el-textarea__inner {
  font-family: Arial, Helvetica, sans-serif !important;
}
.el-input--small .el-input__inner {
  font-family: Arial, Helvetica, sans-serif !important;
}
.ellipsis {
  overflow: hidden; //超出隐藏
  text-overflow: ellipsis; //文本超出时显示省略号
  white-space: nowrap; //强制文本在一行内显示
  display: -webkit-box;
  -webkit-box-orient: vertical; //子元素排列 vertical（竖排）orhorizontal（横排）
  word-wrap: break-word;
  word-break: break-all; //强制换行，包括数字
  -webkit-line-clamp: 1; //内容限制的行数
  line-clamp: 1; //标准属性
  max-width: 100%; //确保有宽度限制
}
.ellipsis2 {
  overflow: hidden; //超出隐藏
  text-overflow: ellipsis; //文本超出时显示省略号

  display: -webkit-box;
  -webkit-box-orient: vertical; //子元素排列 vertical（竖排）orhorizontal（横排）
  word-wrap: break-word;
  word-break: break-all; //强制换行，包括数字
  -webkit-line-clamp: 2; //内容限制的行数
  line-clamp: 2; //标准属性
}
.ellipsis3 {
  overflow: hidden; //超出隐藏
  text-overflow: ellipsis; //文本超出时显示省略号

  display: -webkit-box;
  -webkit-box-orient: vertical; //子元素排列 vertical（竖排）orhorizontal（横排）
  word-wrap: break-word;
  word-break: break-all; //强制换行，包括数字
  -webkit-line-clamp: 3; //内容限制的行数
  line-clamp: 3; //标准属性
}
.el-tabs__item {
  box-shadow: none !important;
  line-height: 36px !important;
  height: 36px !important;
}
.is-disabled {
  .el-textarea__inner {
    color: #606266 !important;
  }
  .el-input__inner {
    color: #606266 !important;
  }
}
.div {
  width: 100%;
  height: 100%;
  padding: 20px;

  background: #fff;
  // overflow: hidden;
}
.el-drawer__header {
  margin: 0;
  padding: 20px;
  font-weight: bold;
  font-size: 20px;
}
.wh100 {
  width: 100%;
  height: 100%;
}
.w100 {
  width: 100%;
}
.h100 {
  height: 100%;
}
.flex {
  display: flex;
}
.flex-juc {
  display: flex;
  justify-content: center;
}
.flex-aic {
  display: flex;
  align-items: center;
}
.flex-juc-aic {
  display: flex;
  justify-content: center;
  align-items: center;
}
.flex-jul-aic {
  display: flex;
  justify-content: left;
  align-items: center;
}
.flex-jur-aic {
  display: flex;
  justify-content: right;
  align-items: center;
}
.flex-wrap {
  display: flex;
  flex-wrap: wrap;
}
.flex1 {
  flex: 1;
}
.tac {
  text-align: center;
}
.num {
  font-size: 36px;
}
.text {
  font-size: 16px;
}
.df {
  display: flex;
}
.aic {
  align-items: center;
}
.juc {
  justify-content: center;
}
.jua {
  justify-content: space-around;
}
.jub {
  justify-content: space-between;
}
.fww {
  flex-wrap: wrap;
}
.cup {
  cursor: pointer;
}
.tac {
  text-align: center;
}
.tal {
  text-align: left;
}
.tar {
  text-align: right;
}
.AIDrawer {
  .el-dialog {
    margin: 0 auto;
  }
  .el-dialog__body {
    padding: 10px 20px;
  }
  .el-dialog__footer {
    padding: 20px;
  }
  .el-dialog__header {
    padding: 20px;
  }
}
.aiMenu {
  .el-dropdown-menu__item {
    line-height: 40px !important;
    font-size: 14px !important;
    font-weight: bold !important;
  }
}
.el-tabs__content {
  height: calc(100% - 37px);
  .el-tab-pane {
    height: 100%;
  }
}
.el-date-editor .el-range-separator {
  padding: 0 !important;
}
.el-range-separator {
  padding: 0 !important;
}
.ql-container {
  height: calc(100% - 80px) !important;
}
.el-table th.el-table__cell > .cell {
  font-weight: bold;
  font-size: 14px;
  color: #000000;
}
.hint-text {
  font-size: 12px;
  color: #686868;
  margin-left: 10px;
}
.dom-card {
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #e8e8e8;
  padding: 10px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
  .dom-card-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 3px;
    border-bottom: 1px solid #eee;
    padding-bottom: 2px;
  }
}
.card-ba {
  background-color: #f8f9fa; /* Light background for small cards */
  color: #333;
  padding: 10px;
  border-radius: 8px;
  height: 100%;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  .card-text {
    font-size: 12px;
    width: 100%;
    color: #666;
    display: flex;
    align-items: center;
    justify-content: center;
    .bold-text {
      font-weight: bold;
      font-size: 16px;
    }
  }
  .card-value {
    width: 100%;
    font-size: 24px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 5px;
  }
  .card-ba-cum {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    font-weight: bold;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    span:first-child {
      display: inline-block;
      width: 40px;
      font-weight: 600;
      opacity: 1;
      font-size: 12px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      color: #666;
    }
    span:last-child {
      display: inline-block;

      font-weight: 700;
      font-size: 12px;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);

      text-align: right;
    }
  }
}
.separator {
  font-size: 12px;
  margin: 0 10px;
}
.el-upload-list__item.is-success.focusing .el-icon-close-tip {
  display: none !important;
}
.table-popper {
  width: 300px !important;
  background: rgba($color: #000000, $alpha: 0.7) !important;
  color: #fff !important;
  font-size: 14px !important;
  .el-popover__title {
    color: #fff !important;
    font-size: 14px !important;
  }

  .popper__arrow::after {
    border-bottom-color: rgba($color: #000000, $alpha: 0.7) !important;
  }
}
</style>
